module.exports = __webpack_public_path__ + "img/H5703.4742e3d4.png";